import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ConfirmationModal from './ConfirmationModal'

/**
 * The question a form dialog asks before it drops what was typed into it, for
 * the dialogs that keep their fields in their own state. DetailsModal and the
 * accordion dialogs ask through `useFormDirtyStore` instead.
 *
 * A click outside a dialog closes it the way the X does (see Modal), so
 * without this one stray click beside a half-filled form threw it away.
 *
 * `requestClose` goes to the dialog's `onClose`. The dialog renders
 * `discardConfirmation` beside itself, as DetailsModal does.
 */
export function useDiscardConfirmation(
  isEdited: boolean,
  close: () => void,
  /** False for a dialog opened from inside another one, as Modal's is. */
  disablePortal?: boolean
) {
  const { t } = useTranslation()
  const [isAsking, setIsAsking] = useState(false)

  const requestClose = () => {
    if (isEdited) setIsAsking(true)
    else close()
  }

  const discardConfirmation = (
    <ConfirmationModal
      isOpen={isAsking}
      title={t('CONFIRMATION_MODAL.TITLE')}
      message={t('CONFIRMATION_MODAL.DESCRIPTION')}
      resetsFormDirty={false}
      disablePortal={disablePortal}
      onClose={() => setIsAsking(false)}
      onConfirm={() => {
        setIsAsking(false)
        close()
      }}
    />
  )

  return { requestClose, discardConfirmation }
}

export default useDiscardConfirmation
